import React, { useState } from 'react';
import { List, Button, Spin, Space } from 'antd';
import {
  ExecuteTaskConseqManual,
  TaskConseqEntityResponse,
} from 'services/workflow';
import { API_URLS } from '../../utils/config';
import { downloadBlobFile } from 'utils/utils2';
import {
  CloudDownloadOutlined,
  //  PrinterOutlined,
  ThunderboltTwoTone,
} from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { manualRunPrintDocumentOrSendEmail } from 'services/printingService';
import { isNull } from 'lodash';

type ConsequencesProps = {
  consequences?: TaskConseqEntityResponse[];
  entityReference?: string;
};

const PRINTING_URL = API_URLS.PRINTING;

const Consequences = (props: ConsequencesProps) => {
  const { consequences, entityReference } = props;

  const [loadingnotif, setloadingnotif] = useState<number>(0);

  const ExecManual = (conseq: TaskConseqEntityResponse) => {
    setloadingnotif(conseq?.notifid);
    ExecuteTaskConseqManual({
      conseqid: conseq.conseqid,
      entity: conseq.entity,
      entityid: conseq.entityid,
      procid: conseq.procID,
      proctaskid: conseq.proctaskID,
      subentity: conseq.subentity,
      subentityid: isNull(conseq.subentityid) ? 0 : conseq.subentityid,
      taskid: conseq.taskid,
      objectreference: entityReference ?? '',
    })
      .then(() => {
        setloadingnotif(0);
      })
      .catch(() => {
        setloadingnotif(0);
      });
  };
  // eslint-disable-next-line no-unused-vars
  const [conseqids, setconseqids] = useState<Array<number>>([]);

  const handleRunManual = (item: any) => {
    setloadingnotif(item.notifid);
    manualRunPrintDocumentOrSendEmail({
      doccode: item.conseqcode,
      conseqid: item.conseqid,
      notifid: item.notifid,
      entityid: item.entityid,
      entity: item.entity,
      subentity: item.subentity ?? '',
      subentityid: item.subentityid ?? 0,

      flagEmail: item.conseqtype === 'EMAIL' ? 'true' : 'false',
      emailTo: item.emailtotarget,
      emailCc: item.emailcctarget,
    })
      .then(() => {
        setloadingnotif(0);
      })
      .catch(() => {
        setloadingnotif(0);
      });
    // disable conseq
    /*    let listCons = conseqids;
    listCons.push(item.conseqid);
    listCons = listCons.slice();
    setconseqids(listCons);*/
  };
  return (
    <List
      itemLayout="horizontal"
      bordered
      dataSource={consequences}
      renderItem={(item) => (
        <List.Item
          actions={[
            item.conseqtype === 'PRINT' || item.conseqtype === 'EMAIL' ? (
              <>
                {item.conseqstatus === 'INPROGRES' && (
                  <Space size="small">
                    <span style={{ margin: '10px' }}>Please wait...</span>
                    <Spin />
                    <Button
                      icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                      onClick={() => handleRunManual(item)}
                      loading={loadingnotif === item?.notifid}
                      disabled={
                        conseqids.indexOf(item.conseqid) !== -1 ? true : false
                      }
                    >
                      <GetLabel label="runmanual" />{' '}
                    </Button>
                  </Space>
                )}
                {item.conseqstatus === 'CLOSED' && (
                  <span style={{ margin: '10px' }}>
                    {item.conseqstatuslabel}
                  </span>
                )}
                {item.conseqstatus === 'ERROR' && (
                  <span style={{ margin: '10px' }}>
                    {item.conseqstatuslabel}
                  </span>
                )}
                {item.conseqstatus === 'INIT' && (
                  <span style={{ margin: '10px' }}>
                    {item.conseqstatuslabel}
                  </span>
                )}
                {item.printid !== null && item.conseqstatus === 'CLOSED' && (
                  <Button
                    size="small"
                    icon={<CloudDownloadOutlined />}
                    onClick={(ev) => {
                      ev.preventDefault();
                      downloadBlobFile(
                        `${item.conseqcode}-${item.entity}-${item.entityid}-${item.conseqid}.pdf`,
                        `${PRINTING_URL}/api/print/download?printid=${item.printid}`
                      );
                    }}
                  >
                    {' '}
                    <GetLabel label="open" />
                  </Button>
                )}

                {item.printid === null && item.notifid !== null && (
                  <Button
                    icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                    onClick={() => handleRunManual(item)}
                    loading={loadingnotif === item?.notifid}
                    disabled={
                      conseqids.indexOf(item.conseqid) !== -1 ? true : false
                    }
                  >
                    <GetLabel label="runmanual" />{' '}
                  </Button>
                )}
              </>
            ) : (
              <>
                <a>{item.conseqstatuslabel}</a>
                {item.conseqstatus === 'INPROGRES' && (
                  <Space size="small">
                    <span style={{ margin: '10px' }}>Please wait...</span>
                    <Spin />
                  </Space>
                )}
              </>
            ),
            (item.conseqstatus === 'ERROR' || item.conseqstatus === 'CLOSED') &&
              item.printid !== null &&
              item.notifid !== null && (
                <>
                  {/*<Button
                loading={loadingnotif == item?.notifid}
                onClick={() => ExecManual(item)}
                icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
              >
                <GetLabel label="runagain" />
              </Button>
              */}
                  <Button
                    icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                    onClick={() => handleRunManual(item)}
                    loading={loadingnotif === item?.notifid}
                    disabled={
                      conseqids.indexOf(item.conseqid) !== -1 ? true : false
                    }
                  >
                    <GetLabel label="runagain" />{' '}
                  </Button>
                </>
              ),
          ]}
        >
          {item.conseqtypelabel}: {item.conseqlabel} {item.tasktargetlabel}
          {item.conseqtype === 'NOTIF' &&
            ` --> Send to ${item.receiverTypeLabel} ( ${
              item.receivername ?? ''
            }${item.receiverRoleProfileLabel ?? ''}${
              item.userNameAction ?? ''
            } )`}
        </List.Item>
      )}
    />
  );
};

export default Consequences;
